/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppContext } from "../../../context";
import { get, post } from "../Common/util";
import * as types from "../../../Actions/actionTypes";
import swishPhoneImg from "./swish-mobile.png";
import { Loader } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  swishContainer: {
    display: "grid",
    gridTemplateColumns: "0.7fr 1.3fr",
    gridTemplateRows: "1fr",
    gap: "0px 16px",
    gridTemplateAreas: ". .",
    maxWidth: "600px",
    margin: "auto",
    marginTop: "24px",
    marginBottom: "24px",
  },
  imageSwish: {
    maxHeight: "250px",
    "@media(max-width: 420px)": {
      maxHeight: "140px",
    },
  },
  progress: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  infoHeader: {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.6",
  },
  infoText: {
    fontSize: "0.875rem",
    lineHeight: "1.53",
  },
  errorText: {
    color: "red",
  },
}));

const Swish = React.memo(() => {
  const { classes } = useStyles();
  const rdxDispatch = useDispatch();

  const [key, setKey] = useState();
  const [errorText, setErrorText] = useState();

  const { state } = useContext(AppContext);
  const { config, saleId, userManager, language } = state;

  console.log("Swish (re)render ------------------------ ");

  const startOnePagePaymentProcessUrl = `${config.apiUri}/api/swish/onepage/${saleId}`;
  const pollOnePagePaymentProcessUrl = (key) =>
    `${config.apiUri}/api/swish/onepage/${saleId}/poll/${key}`;

  // Get Access Token from user
  let accessToken = null;
  userManager.getUser().then((user) => {
    if (user && user.access_token) {
      accessToken = user.access_token;
    }
  });

  const handleResponse = async (apiResponse, allowInit = false) => {
    if (apiResponse.status !== 200) {
      console.log("-- Swish ERROR, status:", apiResponse.status);
      rdxDispatch({
        type: types.ERROR,
        payload: "Could_Not_Start_OnePage_Payment_Error",
      });

      //
      //todo: dölj onepage vid error?
      //
    } else {
      let response = await apiResponse.json();
      console.log("-- Swish - Called api", response);

      if (response) {
        let status = response.status;

        if (status === 1 && response.paymentId && allowInit) {
          console.log("-- Swish - Pending");
          setKey(response.paymentId);
        } else if (status === 0 || status === 2) {
          console.log("-- Swish - Invalid/Error");
          setKey();
          setErrorText("Något gick fel, avbryt betalningen och försök igen");
        } else if (status === 3) {
          console.log("-- Swish - Done");
          setKey();
          window.location.reload();
        } else if (status === 4) {
          console.log("-- Swish - Declined");
          setKey();
          setErrorText(
            "Köpet medgavs ej, kontrollera din betalningsmöjlighet och försök igen"
          );
        }
      }
    }
  };

  //On first render - Call external api
  useEffect(() => {
    console.log("-- Swish - Call API to start payment process");

    const startPaymentProcess = async () => {
      const apiResponse = await post(
        accessToken,
        startOnePagePaymentProcessUrl
      );

      handleResponse(apiResponse, true);

      console.log("-- Swish - Checkout configured");
    };

    startPaymentProcess();
  }, []);

  //Poll API - Executed when key is set
  useEffect(() => {
    if (key) {
      console.log("-- Swish - Setup Poll!");
      const interval = setInterval(() => {
        console.log("-- Swish - Poll!", key);

        get(accessToken, pollOnePagePaymentProcessUrl(key)).then(
          (apiResponse) => {
            console.log("-- Swish - Poll resp!", apiResponse);
            handleResponse(apiResponse, false);
          }
        );
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [key]);

  return (
    <>
      <div id="checkout-container-div">
        <div
          className={`${classes.swishContainer} cart__onepage-checkoutContainerSwish`}
        >
          <div className={"cart__onepage-imageSwishContainer"}>
            <img
              src={swishPhoneImg}
              alt="Swish"
              className={`${classes.imageSwish} cart__onepage-imageSwish`}
            />
          </div>
          <div className={"cart__onepage-helpText"}>
            {!errorText && (
              <>
                <h6 className={classes.infoHeader}>
                  Starta Swish-appen på din telefon och följ instruktionerna...
                </h6>
                <Loader
                  className={`${classes.progress} cart__onepage-progress`}
                  aria-label={language.Swish_Loading}
                />

                <p className={classes.infoText}>
                  Var noga med att växla tillbaka till denna sida efter att du
                  genomfört din betalning. Ladda inte om denna sida och vänta
                  med att stänga ner den tills du blivit förflyttad till
                  kvittosidan, det kan ta en liten stund.
                </p>
              </>
            )}
            {errorText && (
              <>
                <h6 className={classes.infoHeader}>Ett fel inträffade!</h6>
                <p className={`${classes.infoText} ${classes.errorText}`}>
                  {errorText}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default Swish;
